/* eslint-disable react/prop-types */
import { Token } from '@kodiak-finance/sdk-core'
import Step from 'components/StepLine/common/Step'
// import { StepComponent } from 'components/StepLine/types'
import { FarmErrors } from 'lib/hooks/kodiakFarms/useFarmAction'
import { calculateRewardRatePerSecond } from 'pages/KodiakFarmsDeploy/helper'
import { Text } from 'rebass'

import EditForm from './EditForm'
import ReviewForm from './ReviewForm'
import { CardContent, CardDescription, CardHeader, Container, FlexBetween, StepDot, StepIndicator } from './styled'
import { FarmConfig, RewardToken } from './types'

const ConfigurationCard: React.FC<{
  step: 'edit' | 'review'
  config: FarmConfig
  originalConfig: FarmConfig
  allTokens: { [address: string]: Token }
  onStepChange: (step: 'edit' | 'review') => void
  onConfigChange: (config: FarmConfig) => void
  errors: FarmErrors
  loading: boolean
  hasChanges: boolean
  approveSteps: {
    approveStep0?: Step
    approveStep1?: Step
    approveStep2?: Step
  }
  updateConfig: any
  onUpdateComplete: () => Promise<void>
  setErrors: (errors: any) => void
  checkRewardTokenBalances: any
  isBalanceCheckLoading: boolean
}> = ({
  step,
  config,
  originalConfig,
  allTokens,
  onStepChange,
  onConfigChange,
  errors,
  loading,
  hasChanges,
  approveSteps,
  updateConfig,
  onUpdateComplete,
  setErrors,
  checkRewardTokenBalances,
  isBalanceCheckLoading,
}) => {
  // const handleRewardTokenChange = (index: number, field: keyof RewardToken, value: string) => {
  //   onConfigChange({
  //     ...config,
  //     rewardTokens: config.rewardTokens.map((token, i) => (i === index ? { ...token, [field]: value } : token)),
  //   })
  // }

  const handleRewardTokenChange = (index: number, field: keyof RewardToken, value: string) => {
    onConfigChange({
      ...config,
      rewardTokens: config.rewardTokens.map((token, i) =>
        i === index
          ? {
              ...token,
              [field]: value,
              rewardRate:
                field === 'rewardRateFormatted'
                  ? calculateRewardRatePerSecond(
                      value,
                      parseInt(config.rewardsDuration),
                      allTokens[token.tokenAddress]?.decimals ?? 18
                    ).toString()
                  : token.rewardRate,
            }
          : token
      ),
    })
  }

  const handleFieldChange = (field: keyof Omit<FarmConfig, 'rewardTokens'>, value: string) => {
    onConfigChange({
      ...config,
      [field]: value,
    })
  }

  return (
    <Container>
      <CardHeader>
        <FlexBetween>
          <Text fontWeight={600} fontSize="1.25rem">
            Farm Configuration
          </Text>
          <StepIndicator>
            <StepDot active={step === 'edit'} />
            Step {step === 'edit' ? '1/2' : '2/2'}
          </StepIndicator>
        </FlexBetween>
        <CardDescription>
          {step === 'edit' ? 'Configure your farm parameters' : 'Review your changes before saving'}
        </CardDescription>
      </CardHeader>

      <CardContent>
        {step === 'edit' ? (
          <EditForm
            config={config}
            originalConfig={originalConfig as FarmConfig}
            allTokens={allTokens}
            onRewardTokenChange={handleRewardTokenChange}
            onFieldChange={handleFieldChange}
            errors={errors}
            onReview={() => onStepChange('review')}
            loading={loading}
            hasChanges={hasChanges}
            onConfigChange={onConfigChange}
            setErrors={setErrors}
            isBalanceCheckLoading={isBalanceCheckLoading}
          />
        ) : (
          <ReviewForm
            config={config}
            originalConfig={originalConfig as FarmConfig}
            errors={errors}
            onBack={() => onStepChange('edit')}
            loading={loading}
            approveSteps={approveSteps}
            updateConfig={updateConfig}
            refetch={onUpdateComplete}
            checkRewardTokenBalances={checkRewardTokenBalances}
          />
        )}
      </CardContent>
    </Container>
  )
}

export default ConfigurationCard
